import React from "react";
import "./MediaLink.css";

function MediaLink() {
  return (
    <div className="media">
      <a target="_blank" href="https://twitter.com/agarkaryuvraj?lang=en">
        <img src="./twitter.png" />
      </a>
      <a target="_blank" href="https://www.instagram.com/yuvrajcodes/">
        <img src="./insta.jpeg" />
      </a>
      <a target="_blank" href="https://yuvraj-agarkar.medium.com/">
        <img src="./medium.png" className="medium" />
      </a>
      <a
        target="_blank"
        href="https://in.linkedin.com/in/yuvraj-agarkar-770a861a4"
      >
        <img src="./linkedin.png" />
      </a>
      <a target="_blank" href="https://github.com/Yuvraj102">
        <img src="./github.png" />
      </a>
    </div>
  );
}

export default MediaLink;
